/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import Detail from './pages/Detail';
import Scene from './pages/Scene';
import i18n from '../../i18n';
import Homepage from './pages/Homepage';

// 注册路由
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuex)
// 配置路由
const router = new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: `/${process.env.LANG}`,
    },
    {
      path: '/:language',
      component: Homepage,
    },
    {
      path: '/:language/detail/:category_id/:post_id/',
      component: Detail,
    },
    {
      path: '/:language/scene/:category_id/:post_id/',
      component: Scene,
    },
  ],
});

const store = new Vuex.Store({
  state: {
    guideList: [],
    sceneList: [],
  },
  mutations: {
    guideListUpdate (state,list) {
      state.guideList = list;
    },
    sceneListUpdate (state,list) {
      state.sceneList = list;
    },
  },
  actions:{
    guideListUpdate(state,lan) {
      console.log('india env api_url:',`${process.env.API_URL}`);
      Vue.http.get(`${process.env.API_URL}/${lan}/guide/load`).then((response) => {
        if(response.body.code == 200000){
          const guideList = response.body.data.guideLink;
          const sceneList = [];
          let sceneLink = response.body.data.sceneLink;
          sceneLink.groupId = 1;
          sceneList.push(sceneLink)
          // sceneLink.itemList.forEach(function(item){
          //   sceneList.push({
          //     groupId:item.id,
          //     title:item.name,
          //     logoUrl:item.logoUrl
          //   })
          // })
          console.log(1111,sceneList)
          store.commit('guideListUpdate', guideList);
          store.commit('sceneListUpdate', sceneList);
        }else{
          ///错误处理
        }
      }, (response) => {
        //alert('获取列表失败')
      });
    },
  },
})

// 初始化路由
new Vue({
  router,
  store,
  i18n,
  data: {
    path: null,
    guideList:[],
    breadcrumbList: [
      {
        text: '使用文档',
      },
    ],
  },
  created() {
    this.$i18n.locale = this.$route.params.language;
  },
  mounted() {
    if(this.$route.params.language == 'zh') {
      this.breadcrumbList[0].text = '使用文档';
    } else {
      this.breadcrumbList[0].text = 'Guide Documentation';
    }
    store.dispatch('guideListUpdate',this.$route.params.language);
    // store.dispatch('sceneListUpdate',this.$route.params.language);
    this.checkCountry();
  },
  watch: {
    $route() {
      if (this.$i18n.locale !== this.$route.params.language) {
        console.log('route', this.$i18n.locale, this.$route.params.language);
        localStorage.removeItem('apiCategoryData');
        this.$i18n.locale = this.$route.params.language;
        location.reload();
      }
    },
  },
  methods: {
    checkCountry(){
      if(this.$route.path.search('zh') < 0 && this.$route.path.search('en') < 0 && this.$route.path.search('ru') < 0){
        console.log('checkCountry', this.$route.path);
        window.location.href = '';
      }
    },
    // 更新面包屑
    updateBreadcrumb(obj) {
      Vue.set(this.breadcrumbList, 1, obj);
    },
  }
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/modules/index/index.js